import { render, staticRenderFns } from "./EndangeredInfoPopup.vue?vue&type=template&id=fe15d0a4&scoped=true"
import script from "./EndangeredInfoPopup.vue?vue&type=script&lang=js"
export * from "./EndangeredInfoPopup.vue?vue&type=script&lang=js"
import style0 from "./EndangeredInfoPopup.vue?vue&type=style&index=0&id=fe15d0a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe15d0a4",
  null
  
)

export default component.exports